// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3_sE8","tab":"Tabs_tab__1WjF0","tabActive":"Tabs_tabActive__G_Pyp"};